import React, { Component } from "react";
import PropTypes from "prop-types";
import FormControl from "../FormControl";
import FormSectionControl from "../FormSectionControl";
import _ from "lodash";

class FormSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formControls: []
    };
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.draft.length > 0) {
      var element = _.filter(this.props.formControls, function(user) {
        return Number(user.element_id) === Number(nextProps.active_element);
      });

      if (element.length === 0) {
        element = _.filter(this.props.formControls, function(user) {
          return user.element_condition.roles.length > 0;
        });

        element = _.filter(element, function(user) {
          return (
            Number(user.element_condition.roles[0].c_control) ===
            Number(nextProps.active_element)
          );
        });
      }

      if (
        nextProps.formControl.element_type === "18" ||
        nextProps.formControl.element_type === "19"
      ) {
        return true;
      }

      const different =
        Number(this.props.formControl.element_id) ===
          nextProps.active_element ||
        nextProps.validate ||
        this.props.validate !== nextProps.validate;
      if (element.length > 0 || different) {
        return true;
      }
    }

    if (
      nextProps.errors.length !== this.props.errors.length ||
      nextProps.validate ||
      this.props.validate !== nextProps.validate
    ) {
      return true;
    }

    let element2 = _.filter(nextProps.formControls, function(user) {
      return user.element_type === "19";
    });
    if (element2.length > 0) {
      return true;
    }

    return false;
  }

  render() {
    this.props.clearSectionMandatory(this.props.index);

    let controlError = _.filter(this.props.errors, {
      element_id: Number(this.props.formControl.element_id)
    });
    let err = false;

    if (controlError.length > 0) {
      err = controlError[0].required;
    }

    let controlLoading = _.filter(this.props.isLoading, {
      element_id: Number(this.props.formControl.element_id)
    });
    let load = false;

    if (controlLoading.length === 1) {
      load = controlLoading[0].loading;
    }

    let repeatingFormId = this.props.repeatingFormId;
    let repeatingFormUUID = this.props.repeatingFormUUID;

    let eId = this.props.formControl.element_id;
    let repeatingFormEdit = this.props.repeatingFormEdit;
    let repeatingForm = this.props.repeatingForm;
    let element = _.filter(this.props.draft, function(draft) {
      return (
        Number(draft.element_id) === Number(eId) &&
        draft.repeatingFormId ===
          (repeatingFormId !== -1 ? repeatingFormId : undefined) &&
        draft.repeatingFormUUID ===
          (repeatingFormUUID !== -1 ? repeatingFormUUID : undefined)
      );
    });

    if (element.length > 1) {
      element = _.filter(element, function(draft) {
        return (
          draft.repeatingFormEdit ===
          (repeatingFormEdit === undefined ? undefined : repeatingFormEdit)
        );
      });
    }

    let value = "";

    if (element.length === 1) {
      value = element[0].element_value;
    }

    if (this.props.formControls.length > 0) {
      return (
        <div className="formSectionContainer">
          <div
            className="ui form"
            style={{
              paddingLeft: this.props.tablet ? "60px" : "30px",
              paddingRight: this.props.tablet ? "60px" : "30px"
            }}
          >
            <span>
              <FormControl
                repeatingFormUUID={repeatingFormUUID}
                section={this.props.index}
                setMandatory={this.props.setMandatory}
                repeatingForm={this.props.repeatingForm}
                page={this.props.page}
                {...this.props.formControl}
                validate={this.props.validate}
                error={err}
                element_value={value}
                onChange={this.props.onChange}
              />
            </span>
            <FormSectionControl
              index={this.props.index}
              setMandatory={this.props.setMandatory}
              repeatingFormEdit={this.props.repeatingFormEdit}
              repeatingForm={this.props.repeatingForm}
              repeatingFormUUID={this.props.repeatingFormUUID}
              repeatingFormId={this.props.repeatingFormId}
              page={this.props.page}
              errors={this.props.errors}
              formControls={this.props.formControls}
              validate={this.props.validate}
              error={false}
              draft={this.props.draft}
              formControl={this.props.formControl}
              element_value={value}
              onChange={this.props.onChange}
            />
          </div>
        </div>
      );
    }

    if (this.props.formControl.element_visible == "0") {
      return null;
    }

    return (
      <div className="formSectionContainer">
        <div
          className="ui form"
          style={{
            paddingLeft: this.props.tablet ? "60px" : "30px",
            paddingRight: this.props.tablet ? "60px" : "30px"
          }}
        >
          <span>
            <FormControl
              repeatingFormUUID={repeatingFormUUID}
              section={this.props.index}
              setMandatory={this.props.setMandatory}
              repeatingForm={this.props.repeatingForm}
              page={this.props.page}
              {...this.props.formControl}
              validate={this.props.validate}
              error={err}
              element_value={value}
              onChange={this.props.onChange}
            />
          </span>
        </div>
      </div>
    );
  }
}

FormSection.propTypes = {
  formControls: PropTypes.array.isRequired,
  formControl: PropTypes.object.isRequired,
  draft: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  validate: PropTypes.bool.isRequired,
  active_element: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  section: PropTypes.number.isRequired,
  tablet: PropTypes.bool.isRequired
};

export default FormSection;



// WEBPACK FOOTER //
// ./src/components/FormSection/index.js